import { useState, useEffect } from "react";

export const isValidEmailFormat = (values, value) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(values);
};

export const isValidPassword = (values, value) => {
  const { password, passwordConfirm } = values;
  return password === passwordConfirm;
};

export const isValidUrlFormat = (values, value) => {
  const re = /^((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
  return re.test(values);
};

export const isValidPhoneNumberFormat = (values, value) => {
  const re =/^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/
  return re.test(values);
}
